const state = {
  invoiceList: [],
  invoiceTotalAmount: 0
}

const mutations = {
  ADD_TO_INVOICE_LIST(state, items) {
    items.forEach(item => {
      const exists = state.invoiceList.find(i => i.id === item.id)
      if (!exists) {
        state.invoiceList.push(item)
      }
    })
    state.invoiceList = [...state.invoiceList]
    state.invoiceTotalAmount = state.invoiceList.reduce((sum, item) => {
      return sum + (item.brokerageTotal ? parseFloat(item.brokerageTotal) : 0)
    }, 0)
  },
  REMOVE_FROM_INVOICE_LIST(state, id) {
    state.invoiceList = state.invoiceList.filter(item => item.id !== id)
    state.invoiceTotalAmount = state.invoiceList.reduce((sum, item) => {
      return sum + (item.brokerageTotal ? parseFloat(item.brokerageTotal) : 0)
    }, 0)
  },
  CLEAR_INVOICE_LIST(state) {
    state.invoiceList = []
    state.invoiceTotalAmount = 0
  }
}

const actions = {
  addToInvoiceList({ commit }, items) {
    commit('ADD_TO_INVOICE_LIST', items)
  },
  removeFromInvoiceList({ commit }, id) {
    commit('REMOVE_FROM_INVOICE_LIST', id)
  },
  clearInvoiceList({ commit }) {
    commit('CLEAR_INVOICE_LIST')
  }
}

const getters = {
  invoiceList: state => state.invoiceList,
  invoiceTotalAmount: state => state.invoiceTotalAmount,
  invoiceCount: state => state.invoiceList.length
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
